

























import { Vue, Component, Prop } from 'vue-property-decorator';
import { headers } from '@/pantallas/SucursalVirtual/MisVisitas/misVisitasHeaders';

@Component
export default class TablaMisVisitas extends Vue {
  @Prop({ default: [] }) visitas: any;
  @Prop({ default: '' }) busqueda: string;
  encabezados = headers;
  pageConfig = {
    rowsPerPage: 25,
  };
}
